import {
  ContractDemandDetailWidget as ContractDemandDetailWidgetBase,
  FormWidgetI18nConfig,
} from '@procureai/ui-modules-mui';

import { I18nNamespace } from '~/common/types';
import { ModuleHash } from '~/modules/Module.types';

import { useContractDetailWidgetBackend } from './ContractDemandDetailWidget.hooks.tsx';

const i18n: FormWidgetI18nConfig = { ns: I18nNamespace.widgets, keyPrefix: 'ContractDemandDetailWidget' };

export const ContractDemandDetailWidget = () => {
  return (
    <ContractDemandDetailWidgetBase
      i18n={i18n}
      useBackend={useContractDetailWidgetBackend}
      navigationHash={ModuleHash.CONTRACT_DEMAND_DETAIL}
      intercomTarget={i18n.keyPrefix}
    />
  );
};
